import { useState } from 'react';
import './DeleteConfirmModal.css';

const API_URL = import.meta.env.VITE_API_URL || '';

const DeleteConfirmModal = ({ project, onConfirm, onCancel }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Verify credentials before allowing deletion
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        setError('Invalid username or password');
        setLoading(false);
        return;
      }

      // Credentials verified - proceed with deletion
      onConfirm();
    } catch (err) {
      console.error('Authentication error:', err);
      setError('Authentication failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={onCancel}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header">
          <div className="warning-icon">⚠️</div>
          <h2>Confirm Deletion</h2>
          <button 
            className="modal-close"
            onClick={onCancel}
            type="button"
          >
            ×
          </button>
        </div>

        <div className="delete-modal-body">
          <div className="project-info">
            <p className="delete-warning">
              You are about to permanently delete:
            </p>
            <div className="project-preview">
              <strong>{project.title}</strong>
              <span className="project-category">{project.category}</span>
            </div>
            <p className="delete-consequences">
              This action will:
            </p>
            <ul className="consequences-list">
              <li>❌ Remove project from database</li>
              <li>❌ Delete all associated media files</li>
              <li>❌ Remove from live website</li>
              <li>⚠️ <strong>Cannot be undone!</strong></li>
            </ul>
          </div>

          <div className="auth-divider">
            <span>Verify your identity to continue</span>
          </div>

          <form onSubmit={handleSubmit} className="delete-auth-form">
            <div className="form-group">
              <label htmlFor="delete-username">Username</label>
              <input
                type="text"
                id="delete-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                autoComplete="username"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="delete-password">Password</label>
              <input
                type="password"
                id="delete-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                autoComplete="current-password"
                required
              />
            </div>

            {error && (
              <div className="delete-error">
                🚫 {error}
              </div>
            )}

            <div className="modal-actions">
              <button
                type="button"
                onClick={onCancel}
                className="cancel-btn"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="confirm-delete-btn"
                disabled={loading}
              >
                {loading ? 'Verifying...' : 'Confirm & Delete'}
              </button>
            </div>
          </form>
        </div>

        <div className="delete-modal-footer">
          <p>🔒 Secure deletion requires authentication</p>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

